import { OFFERS_COMPARISON_EXPERIMENT } from '../constants/config/experiments';
import { checkNewExperiment } from './experiments/checkNewExperiment';

export function checkCompareEnabled(): boolean {
  /* istanbul ignore next */
  if (typeof window === 'undefined') {
    return false;
  }

  return checkNewExperiment(window.__header_experiments__ || [], OFFERS_COMPARISON_EXPERIMENT, 'enabled');
}
